import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import MakeAPICall from "../../apiCalls/common";
import MedicinalCannabisLogo from "../../assets/images/medicinal_cannabis_logo.png";
import {
  addInstantSwitchConsultDetailsMedicinalCannabisAPI,
  changeInstantSwitchConsultDetailsSequenceMedicinalCannabisAPI,
  deleteSwitchConsultDetailsMedicinalCannabisAPI,
  editSwitchConsultDetailsMedicinalCannabisAPI,
  getConstansApiRoute,
  getInstantSwitchConsultDetailsMedicinalCannabisAPI,
  updateConstantsApiRoute
} from "../../apiRoutes";

import { sortData } from "../../utils/commonMethods";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import CustomDataTable from "../../components/datatable/customDataTable";
import Button from "../../components/button";
import ConsultGstForm from "../../containers/ConsultCost/consultGstForm";
import ConsultPmFeeForm from "../../containers/ConsultCost/consultPmFeeForm";
import EditCostSequence from "../../containers/ConsultCost/editCostSequence";
import InstantSwitchConsultCostForm from "../../containers/ConsultCost/instantSwitchConsultCostForm";

const InstantSwitchConsultCostTable = (props) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [serverConstants, setServerConstants] = useState(null);
  const [consultsCostList, setConsultsCostList] = useState([]);
  const [filteredConsultsCostList, setFilteredConsultsCostList] = useState([]);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [selConsult, setSelConsult] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const [consultFormModalTitle, setConsultFormModalTitle] = useState("");
  const [showConsultFormModal, setShowConsultFormModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [showGstModal, setShowGstModal] = useState(false);
  const [showPmFeeModal, setShowPmFeeModal] = useState(false);
  const [showEditSeqModal, setShowEditSeqModal] = useState(false);

  let excelSheetHeader = [
    {
      label: "Sequence Number",
      key: "Sequence_Number"
    },
    {
      label: "Consult Cost",
      key: "Consult_Cost"
    },
    // {
    //     label: "Consult Duration",
    //     key: "Consult_Duration"
    // },
    {
      label: "Consult Description",
      key: "Consult_Description"
    }
  ];

  let tableHeaders = [
    {
      key: "id",
      value: "Sr No."
    },
    {
      key: "price",
      value: "Consult Cost ($)"
    },
    // {
    //     key: "content",
    //     value: "Consult Duration"
    // },
    {
      key: "description",
      value: "Consult Description"
    }
  ];

  if (props.user.userType === "SUPER_ADMIN") {
    tableHeaders.push.apply(tableHeaders, [{ key: "Action", value: "Action" }]);
  }

  // create custom table filter function
  const customSearchTableByText = query => {
    let newList = consultsCostList.filter(item => {
      if (item.id === parseInt(query)) {
        return true;
      } else if (item.description.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (
        item.consultPrice.toLowerCase().includes(query.toLowerCase())
      ) {
        return true;
      }
      return false;
    });

    setFilteredConsultsCostList(newList);
  };

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = filters.limit;
      newFilter.skip = filters.skip;

      setCurrFilters(newFilter);
    }
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(
      SelColumn.column,
      SelColumn.order,
      filteredConsultsCostList
    );
    setFilteredConsultsCostList(sortedData);
  };

  // handle all data table pagination at frontend
  const filterConsultList = list => {
    let newList = [];
    if (list) {
      newList = list.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    } else {
      newList = consultsCostList.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    }

    setFilteredConsultsCostList(newList);
  };

  // get constants
  const getServerConstants = () => {
    setApiCallParams1({
      reqType: "GET",
      reqUrl: getConstansApiRoute,
      successCallback: res => {
        setServerConstants(res.data.data);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update server constants
  const updateServerConstants = (formData, formType, isKeySpecified) => {
    setShowPmFeeModal(false);
    setShowGstModal(false);
    setIsProcessing(true);


    let formDataSpecific = new FormData();
    if (isKeySpecified) {
      formDataSpecific.append(isKeySpecified, formData.fee);
    }

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: updateConstantsApiRoute,
      dataObj: isKeySpecified ? formDataSpecific : formData,
      successCallback: res => {
        setIsProcessing(false);
        if (formType === "PMF" || isKeySpecified) {
          setModalText("Practice Management Fee Updated Successfully");
        } else {
          setModalText("GST on Practice Management Fee Updated Successfully");
        }
        setShowTextModal(true);
        getServerConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // get nature of consults
  const getConsults = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: props.getAPI,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        let excelList = [];
        await res.data.data.consultDetailData.forEach((column, index) => {
          let d = {};
          let e = {};

          d._id = column._id;
          d.id = index + 1;
          // d.content =
          //     column.consultMode + " " + column.consultDuration + " Mins";
          d.consultPrice = parseFloat(column.consultPrice).toFixed(2);
          d.price = column.consultPrice;
          if (column.description) {
            d.description = column.description;
          } else {
            d.description = " ";
          }
          // d.consultDuration = column.consultDuration;
          // d.consultMode = column.consultMode;

          e.Sequence_Number = index + 1;
          e.Consult_Cost = column.consultPrice;
          // e.Consult_Duration =
          //     column.consultMode + " " + column.consultDuration + " Mins";
          if (column.description) {
            e.Consult_Description = column.description;
          } else {
            e.Consult_Description = " ";
          }

          list.push(d);
          excelList.push(e);
        });
        setConsultsCostList(list);
        setTotalRecords(res.data.data.totalCount);
        setExcelSheetData(excelList);
        filterConsultList(list);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // delete consult
  const delSelConsult = () => {
    setShowDelModal(false);
    setIsProcessing(true);

    let parm = {
      consultDetailId: selConsult._id
    };

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: props.deleteAPI,
      params: parm,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Consult Cost Deleted Successfully.");
        setShowTextModal(true);
        getConsults();
        setSelConsult(null);
      },
      failureCallback: err => {
        setSelConsult(null);
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // add new consult
  const addNewConsult = values => {
    setShowConsultFormModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: props.addAPI,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Consult Cost Added Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // edit consult
  const editSelConsult = values => {
    setShowConsultFormModal(false);
    setSelConsult(null);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: props.editAPI,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Consult Cost Updated Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update consult sequence
  const updateConsultSequence = newSeq => {
    setShowEditSeqModal(false);
    setIsProcessing(true);

    var array = [];
    for (var x = 0; x < newSeq.length; x++) {
      array.push({
          consultId: newSeq[x]._id,
          seqNo: x
        }
      );
    }

    // var formData = new FormData();
    // formData.append("sequence", JSON.stringify(array));
    const dataToSend = {
      sequence: array
    };

    setApiCallParams({
      reqType: "PUT",
      reqUrl: props.sequenceAPI,
      dataObj: dataToSend,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Sequence Changed Successfully");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //     "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    if (consultsCostList.length === 0) {
      getConsults();
    }

    if (serverConstants === null) {
      getServerConstants();
    }

    filterConsultList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const showSelUpdateModal = item => {
    setSelConsult(item);
    setConsultFormModalTitle("Edit Consult Cost");
    setShowConsultFormModal(true);
  };

  const showConsultAddModal = () => {
    setConsultFormModalTitle("Add Consult Cost");
    setShowConsultFormModal(true);
  };

  const showSelDelModal = item => {
    setSelConsult(item);
    setShowDelModal(true);
  };

  const togglePmFeeModal = () => {
    setShowPmFeeModal(!showPmFeeModal);
  };

  const toggleGstModal = () => {
    setShowGstModal(!showGstModal);
  };

  return (
    <>
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      <CustomModal
        openModal={showEditSeqModal}
        cancelEvent={() => {
          setShowEditSeqModal(false);
        }}
        title="Edit Sequence"
        modalBodyContent={
          <EditCostSequence
            consults={consultsCostList}
            onUpdate={updateConsultSequence}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showGstModal}
        cancelEvent={toggleGstModal}
        title={props.gstModalTitle}
        modalBodyContent={
          <ConsultGstForm
            gstName={props.gstModalTitle}
            gst={
              serverConstants ? serverConstants.tax.toFixed(2).toString() : ""
            }
            onUpdateFormSubmit={(formData) => updateServerConstants(formData, null, null)}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showPmFeeModal}
        cancelEvent={togglePmFeeModal}
        title={props.feeModalTitle}
        modalBodyContent={
          <ConsultPmFeeForm
            feeName={props.feeModalTitle}
            fee={
              serverConstants && serverConstants[props.constantKey] ? serverConstants[props.constantKey].toFixed(2).toString() : ""
            }
            isCustomData={true}
            onUpdateFormSubmit={(formVal) => updateServerConstants(formVal, null, props.constantKey)}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal

        className="modal-lg"
        openModal={showConsultFormModal}
        cancelEvent={() => {
          setShowConsultFormModal(false);
          setSelConsult(null);
        }}
        title={consultFormModalTitle}
        modalBodyContent={
          <InstantSwitchConsultCostForm
            consult={selConsult}
            onAddSubmit={addNewConsult}
            onEditSubmit={editSelConsult}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelModal}
        cancelEvent={() => {
          setShowDelModal(false);
          setSelConsult(null);
          console.log("set selected modal null");
        }}
        okayEvent={delSelConsult}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this consult cost?
          </p>
        }
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : "mb-4"}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h4>{props.title}</h4>
          {props.user.userType === "SUPER_ADMIN" && (
            <div className="d-flex flex-column align-items-end">
              <div className="d-flex flex-row align-items-end mb-4">
                <Button
                  className="ic-btn-grey"
                  clickEvent={togglePmFeeModal}
                  title={props.feeModalTitle}
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  className="ic-btn-grey"
                  clickEvent={toggleGstModal}
                  title={props.gstModalTitle}
                ></Button>
              </div>
              <div className="d-flex flex-row align-items-end">
                <Button
                  clickEvent={() => {
                    setShowEditSeqModal(true);
                  }}
                  title="Edit Sequence"
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  clickEvent={showConsultAddModal}
                  title="Add Consult Cost"
                ></Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <CSVLink
                  className="no-text-decoration"
                  filename={"Consult Costs.csv"}
                  data={excelSheetData}
                  headers={excelSheetHeader}
                >
                  <Button title="Export to CSV"></Button>
                </CSVLink>
              </div>
            </div>
          )}
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {filteredConsultsCostList.map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td>
              <td>$&nbsp;{item.consultPrice}</td>
              <td>{item.description}</td>
              {props.user.userType === "SUPER_ADMIN" && (
                <td>
                  <button
                    type="button"
                    className="btn btn-out-bell high-z-index ml-2"
                    onClick={() => showSelUpdateModal(item)}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() => showSelDelModal(item)}
                    type="button"
                    className="btn btn-out-delete high-z-index ml-2"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              )}
            </tr>
          ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
        <MakeAPICall apiParam={apiCallParams1} />
      </div>
    </>
  );
};

const InstantSwitchConsultCost = (props) => {
  return <div className="view-ticket-container consult-nature-page-container">
    <div className="pb-3">
      <h3>Consult Costs</h3>
      <img src={MedicinalCannabisLogo} alt="Instant_Switch_logo" className="company_logo" />
    </div>
    <InstantSwitchConsultCostTable
      {...props}
      title="Medicinal Cannabis"
      feeModalTitle="Practice Management Fee ($)"
      // gstModalTitle="GST on Medicinal Cannabis Management Fee (%)"
      gstModalTitle="GST on Practice Management Fee (%)"
      sequenceAPI={changeInstantSwitchConsultDetailsSequenceMedicinalCannabisAPI}
      addAPI={addInstantSwitchConsultDetailsMedicinalCannabisAPI}
      getAPI={getInstantSwitchConsultDetailsMedicinalCannabisAPI}
      editAPI={editSwitchConsultDetailsMedicinalCannabisAPI}
      deleteAPI={deleteSwitchConsultDetailsMedicinalCannabisAPI}
      constantKey="instantSwitchMedicinalCannabisPMFee"
    />
  </div>;
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps, null)(InstantSwitchConsultCost);

